import { css } from 'styled-components';
export const buttonIconsColorMixin = css`
  & svg {
    fill: ${({
  disabled,
  inactive,
  disabledColor,
  color,
  disabledIconColor,
  iconColor
}) => /* prettier-ignore */
disabled && !inactive ? disabledIconColor || disabledColor : iconColor || color};
  }

  ${({
  inactive,
  disabled,
  $hasTouch,
  hoverColor,
  hoverIconColor,
  focusColor,
  focusIconColor
}) => !inactive && !disabled && !$hasTouch && `
      &:hover {
        & svg {
          ${hoverIconColor || hoverColor ? `fill: ${hoverIconColor || hoverColor};` : ''}
        }
      }
      &:focus {
        & svg {
          ${focusIconColor || focusColor ? `fill: ${focusIconColor || focusColor};` : ''}
        }
      }
    `}

  ${({
  inactive,
  disabled,
  activeColor,
  activeIconColor
}) => !inactive && !disabled && `
      &:active {
        & svg {
          ${activeIconColor || activeColor ? `fill: ${activeIconColor || activeColor};` : ''}
        }
      }
    `}
`;
export const buttonIconsColorKeys = ['iconColor', 'activeIconColor', 'hoverIconColor', 'focusIconColor', 'disabledIconColor'];